import i18n from 'i18next';
import { action, makeObservable, observable } from 'mobx';

import { getQueryParams } from '../../utils/getQueryParams';
import { dealerStore } from '../index';

class GlobalStore {
  isFetching = false;
  isFetchingCalculation = false;
  isZipCodeValid = true;
  statusBar = {
    message: '',
    isVisible: false,
  };
  zipcode = '';
  tdaCode = '';
  onlySelectedVin = false;

  constructor() {
    makeObservable(this, {
      isFetching: observable,
      isFetchingCalculation: observable,
      isZipCodeValid: observable,
      zipcode: observable,
      statusBar: observable,
      tdaCode: observable,
      onlySelectedVin: observable,
      setGlobalParams: action,
      setLanguageFromQueryParams: action,
      setZipCode: action,
      setIsZipCodeValid: action,
      setStatusBar: action,
      setTdaCode: action,
      setOnlySelectedVin: action,
    });
  }

  setGlobalParams = () => {
    const { zipcode } = getQueryParams();

    if (zipcode) {
      this.zipcode = zipcode as string;
      dealerStore.getDealers();
    }

    this.setLanguageFromQueryParams();
  };

  setLanguageFromQueryParams = () => {
    // grabs language from query string and sets it internally if present...
    const { lang } = getQueryParams();

    if (lang && (lang === 'es' || lang === 'en')) {
      i18n.changeLanguage(lang);
    }
  };

  setZipCode = (zipcode: string) => {
    this.zipcode = zipcode;
  };

  setIsZipCodeValid = (isZipCodeValid: boolean) => {
    this.isZipCodeValid = isZipCodeValid;
  };

  setStatusBar = (isStatusBarVisible: boolean, message: string) => {
    this.statusBar.isVisible = isStatusBarVisible;
    this.statusBar.message = message;
  };

  setTdaCode = (tdaCode: string) => {
    this.tdaCode = tdaCode;
  };

  setOnlySelectedVin = (onlySelectedVin: boolean) => {
    this.onlySelectedVin = onlySelectedVin;
  };
}

export default GlobalStore;
